import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5720fbd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row gx-0 p-4 px-lg-5" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted d-flex min-vh-80 justify-content-center align-items-center flex-column"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "OCURRIÓ UN ERROR", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "No pudimos obtener la información solicitada", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Seleccioná otra opción para resolver el problema", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "col-12"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = { class: "d-flex justify-content-between flex-xl-row flex-column align-items-start" }
const _hoisted_10 = { class: "mb-lg-4" }
const _hoisted_11 = { class: "mb-0" }
const _hoisted_12 = { class: "text-uppercase fw-bold mb-0" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "col-12 my-4" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Libre acceso - capacidad limitada."),
  /*#__PURE__*/_createElementVNode("strong", null, " Reserva es válida para 4 asistentes (1 titular + 3 acompañantes) ")
], -1))
const _hoisted_16 = { class: "d-flex" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "d-block d-md-none w-100 text-center my-4"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "→", -1))
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12 mb-5" }
const _hoisted_23 = { class: "d-flex mb-5 align-items-start flex-column" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-4" }, " Sección exclusiva para usuarios registrados ", -1))
const _hoisted_25 = { class: "mb-5" }
const _hoisted_26 = { class: "mb-5" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Si ya tenes una cuenta, podes iniciar sesión desde el siguiente botón ", -1))
const _hoisted_28 = { class: "mb-4" }
const _hoisted_29 = { class: "fw-bold" }
const _hoisted_30 = { class: "fw-bold" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "RECORDÁ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Si ya cargaste la documentación de tu/s vehículo/s, estos deben pasar el proceso de verificacIón. Por lo general, este proceso se realiza de forma automática. En caso de que no tengamos tu información, este proceso puede verse demorado hasta que realicemos la verificación de la documentación. ")
], -1))
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = { class: "mb-4" }
const _hoisted_34 = { class: "fw-bold" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Inicia sesión o registrate a continuación para acceder a beneficios exclusivos. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingSkeletonDetail = _resolveComponent("LoadingSkeletonDetail")!
  const _component_AppContentButtonsComponent = _resolveComponent("AppContentButtonsComponent")!
  const _component_TheReserveDay = _resolveComponent("TheReserveDay")!
  const _component_AppSelectCard = _resolveComponent("AppSelectCard")!
  const _component_DetailSeccion = _resolveComponent("DetailSeccion")!
  const _component_TheCupones = _resolveComponent("TheCupones")!
  const _component_TheSorteo = _resolveComponent("TheSorteo")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_LoadingSkeletonDetail)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("h6", _hoisted_11, _toDisplayString(_ctx.t('titles.actividad.Stitle2')), 1),
                _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.navigation.actividad?.title), 1),
                _createElementVNode("h5", {
                  class: "text-uppercase mb-0",
                  innerHTML: _ctx.navigation.actividad?.subtitle
                }, null, 8, _hoisted_13)
              ])
            ]),
            (_ctx.actividadVer.nombre)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  false
                    ? (_openBlock(), _createBlock(_component_AppContentButtonsComponent, {
                        key: 0,
                        "disabled-return": false,
                        "go-back": _ctx.getters.actualUbicacionURL,
                        disabledContinue: false,
                        urlRedirect: _ctx.getters.actualFormularioURL
                      }, null, 8, ["go-back", "urlRedirect"]))
                    : _createCommentVNode("", true),
                  (_ctx.getters.tipoActividad.toString() === 'info')
                    ? (_openBlock(), _createBlock(_component_AppContentButtonsComponent, {
                        key: 1,
                        "disabled-return": false,
                        "go-back": _ctx.getters.actualUbicacionURL,
                        disabledContinue: true
                      }, null, 8, ["go-back"]))
                    : (
            (_ctx.getters.tipoActividad.toString() === 'academy' ||
              _ctx.getters.tipoActividad.toString() === 'academy_fidelizacion') &&
            !_ctx.actividadVer.exclusivo
          )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(_component_TheReserveDay),
                          _createVNode(_component_AppContentButtonsComponent, {
                            "disabled-return": false,
                            "go-back": _ctx.getters.actualUbicacionURL,
                            disabledContinue: !_ctx.state.navigation.turno,
                            urlRedirect: _ctx.getters.actualFormularioURL
                          }, null, 8, ["go-back", "disabledContinue", "urlRedirect"])
                        ], 64))
                      : (
            _ctx.getters.tipoActividad.toString() === 'recital' &&
            !_ctx.actividadVer.exclusivo
          )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createElementVNode("div", _hoisted_14, [
                              _hoisted_15,
                              _createElementVNode("div", _hoisted_16, [
                                false
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "submit",
                                      disabled: _ctx.turnosVip === true,
                                      class: _normalizeClass(["btn btn-primary px-4 py-2 text-uppercase me-3 justify-content-center", { 'select-btn': _ctx.turnosVip === true }]),
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.verTurnosVip(true)))
                                    }, " vip exclusivo ", 10, _hoisted_17))
                                  : _createCommentVNode("", true),
                                (_ctx.habilitarGeneral)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "submit",
                                      disabled: _ctx.turnosVip === false,
                                      class: _normalizeClass([{ 'select-btn': _ctx.turnosVip === false }, "btn btn-primary px-4 py-2 text-uppercase me-3 justify-content-center"]),
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.verTurnosVip(false)))
                                    }, " Campo general ", 10, _hoisted_18))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (_ctx.turnosVip !== null)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_ctx.turnosVip)
                                    ? (_openBlock(), _createBlock(_component_TheReserveDay, {
                                        key: 0,
                                        "con-acceso-vip": _ctx.turnosVip
                                      }, null, 8, ["con-acceso-vip"]))
                                    : (_openBlock(), _createBlock(_component_TheReserveDay, {
                                        key: 1,
                                        "con-acceso-vip": _ctx.turnosVip
                                      }, null, 8, ["con-acceso-vip"]))
                                ], 64))
                              : _createCommentVNode("", true),
                            _createVNode(_component_AppContentButtonsComponent, {
                              "disabled-return": false,
                              "go-back": _ctx.getters.actualUbicacionURL,
                              disabledContinue: !_ctx.state.navigation.turno,
                              urlRedirect: _ctx.getters.actualFormularioURL
                            }, null, 8, ["go-back", "disabledContinue", "urlRedirect"])
                          ], 64))
                        : (
            _ctx.getters.tipoActividad.toString() === 'cupos_limitados' &&
            !_ctx.actividadVer.exclusivo
          )
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                              (!_ctx.actividadVer.exclusivo)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(_component_TheReserveDay, { "con-acceso-vip": false }),
                                    _createVNode(_component_AppContentButtonsComponent, {
                                      "disabled-return": false,
                                      "go-back": _ctx.getters.actualUbicacionURL,
                                      disabledContinue: !_ctx.state.navigation.turno,
                                      urlRedirect: _ctx.getters.actualFormularioURL
                                    }, null, 8, ["go-back", "disabledContinue", "urlRedirect"])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true),
                  (
            _ctx.getters.tipoActividad.toString() === 'testdrive' ||
            _ctx.getters.tipoActividad.toString() === 'travesia' ||
            _ctx.getters.tipoActividad.toString() === 'contacto' ||
            _ctx.getters.tipoActividad.toString() === 'contacto_vehicular'
          )
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createVNode(_component_AppSelectCard, {
                          service: _ctx.vehicleService,
                          class: "select d-flex flex-nowrap flex-lg-wrap overflow-auto",
                          primaryNavigation: false,
                          onReady: _ctx.ready,
                          onCallback: _ctx.completeSelection,
                          preselect: _ctx.route.params?.seleccionId,
                          "list-id": parseInt(_ctx.route.params?.actividadId.toString())
                        }, null, 8, ["service", "onReady", "onCallback", "preselect", "list-id"]),
                        (_ctx.totalCard > 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createTextVNode(" Deslizá "),
                              _hoisted_20,
                              _createTextVNode(" para ver todos nuestros vehículos ")
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_AppContentButtonsComponent, {
                          "disabled-return": false,
                          "go-back": _ctx.getters.actualUbicacionURL,
                          disabledContinue: !_ctx.state.navigation.vehiculo,
                          urlRedirect: _ctx.getters.actualActividadConVehiculoURL
                        }, null, 8, ["go-back", "disabledContinue", "urlRedirect"])
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DetailSeccion, {
                    video: 
            _ctx.actividadVer.id === 46
              ? '/video/promo_42.mp4'
              : _ctx.actividadVer.id === 76
              ? '/video/promo_42.mp4'
              : _ctx.actividadVer.id === 115
              ? '/video/promo_42.mp4'
              : _ctx.actividadVer.id === 123
              ? '/video/promo_42.mp4'
              : _ctx.actividadVer.id === 70
              ? '/video/promo_70.mp4'
              : undefined
          ,
                    title: _ctx.actividadVer.nombre,
                    "sub-title": _ctx.actividadVer.subtitulo,
                    imgs: _ctx.actividadVer.slider,
                    html: _ctx.actividadVer.descripcion,
                    "only-info": 
            Boolean(_ctx.state.evento?.fidelizacion) ||
            _ctx.getters.tipoActividad.toString() === 'info'
          
                  }, null, 8, ["video", "title", "sub-title", "imgs", "html", "only-info"]),
                  (_ctx.getters.tipoActividad.toString() === 'cupones')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        (!_ctx.actividadVer.exclusivo)
                          ? (_openBlock(), _createBlock(_component_TheCupones, {
                              key: 0,
                              id: _ctx.actividadVer.id,
                              nombre: _ctx.actividadVer.nombre
                            }, null, 8, ["id", "nombre"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.getters.tipoActividad.toString() === 'sorteo')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        (!_ctx.actividadVer.exclusivo)
                          ? (_openBlock(), _createBlock(_component_TheSorteo, {
                              key: 0,
                              id: _ctx.actividadVer.id
                            }, null, 8, ["id"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.actividadVer.exclusivo || _ctx.actividadVer.registrados)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        (_ctx.actividadVer.registrados || !_ctx.state.evento?.fidelizacion)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _hoisted_24,
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("p", null, " Para continuar es necesario que generes una cuenta de usuario en " + _toDisplayString(_ctx.state.evento?.nombre) + ". ", 1),
                                _createVNode(_component_router_link, {
                                  to: { name: 'Register' },
                                  class: "btn btn-sm bg-light text-dark",
                                  tag: "button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Registrarme ")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _hoisted_27,
                                _createVNode(_component_router_link, {
                                  to: { name: 'Register' },
                                  class: "btn btn-sm bg-light text-dark",
                                  tag: "button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" iniciar sesión ")
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              (_ctx.getters.isLogin)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("h3", _hoisted_28, [
                                      _createTextVNode(" Sección exclusiva para miembros verificados de "),
                                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.state.evento?.nombre), 1)
                                    ]),
                                    _createElementVNode("p", null, [
                                      _createTextVNode(" Para ser miembro es necesario que verifiquemos que sos titular de un "),
                                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.state.evento?.marca), 1),
                                      _createTextVNode(" . ")
                                    ]),
                                    _hoisted_31,
                                    _createElementVNode("p", null, [
                                      _createTextVNode(" Si aun no cargaraste tu/s "),
                                      _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.state.evento?.marca), 1),
                                      _createTextVNode(", podes hacerlo desde el siguiente botón. ")
                                    ]),
                                    _createVNode(_component_router_link, {
                                      to: { name: 'MiCuenta' },
                                      class: "btn btn-sm bg-light text-dark mt-4",
                                      tag: "button"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Registrar vehículo/s ")
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("h3", _hoisted_33, [
                                      _createTextVNode(" Contenido exclusivo para miembros "),
                                      _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.state.evento?.nombre), 1)
                                    ]),
                                    _hoisted_35,
                                    _createVNode(_component_router_link, {
                                      to: { name: 'Register' },
                                      class: "btn btn-sm bg-light text-dark mt-4",
                                      tag: "button"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Quiero ser miembro ")
                                      ]),
                                      _: 1
                                    })
                                  ], 64))
                            ], 64))
                      ])
                    ])
                  ]),
                  (!_ctx.state.evento?.fidelizacion)
                    ? (_openBlock(), _createBlock(_component_AppContentButtonsComponent, {
                        key: 0,
                        "disabled-return": false,
                        "go-back": _ctx.getters.actualUbicacionURL,
                        disabledContinue: true,
                        urlRedirect: {}
                      }, null, 8, ["go-back"]))
                    : (_openBlock(), _createBlock(_component_AppContentButtonsComponent, {
                        key: 1,
                        "disabled-return": true,
                        "go-back": _ctx.getters.actualUbicacionURL,
                        disabledContinue: true,
                        urlRedirect: {}
                      }, null, 8, ["go-back"]))
                ], 64))
              : _createCommentVNode("", true)
          ]))
  ]))
}